document.querySelectorAll('[slider-d5]').forEach((slider) => {
  const arrowsEnabled = slider.getAttribute('slider-arrows') === 'true';
  const paginationEnabled = slider.getAttribute('slider-pagination') === 'true';
  const countEnabled = slider.getAttribute('slider-count') === 'true';
  const autoplayEnabled = slider.getAttribute('slider-autoplay') === 'true';
  const autoplayTime = parseInt(slider.getAttribute('slider-autoplay-time'), 10) || 5000;

  const tracks = Array.from(slider.querySelectorAll('[slider-track-d5]'));
  if (!tracks.length) return;

  const primaryTrack = tracks[0];
  const primarySlides = Array.from(
    primaryTrack.querySelectorAll('[slider-slide-d5]')
  );
  if (!primarySlides.length) return;

  const total = primarySlides.length;
  const trackData = tracks.map((track) => ({
    track,
    slides: Array.from(track.querySelectorAll('[slider-slide-d5]'))
  }));

  const countEl = slider.querySelector('[slider-count-d5]');
  const paginationEl = slider.querySelector('[slider-pagination-d5]');
  const playPauseBtn = slider.querySelector('[slider-play-pause-d5]');
  const nextBtn = slider.querySelector('[slider-next-d5]');
  const prevBtn = slider.querySelector('[slider-prev-d5]');

  if (!arrowsEnabled) {
    if (nextBtn) nextBtn.style.display = 'none';
    if (prevBtn) prevBtn.style.display = 'none';
  }
  if (!paginationEnabled && paginationEl) paginationEl.style.display = 'none';
  if (!countEnabled && countEl) countEl.style.display = 'none';

  let currentIndex = 0;
  let autoplayTimer = null;
  let isPlaying = autoplayEnabled;
  let isSyncing = false;
  let slideStartTime = null;
  let remainingTime = null;

  function getTrackPadding(track) {
    return parseFloat(getComputedStyle(track).paddingLeft) || 0;
  }

  function getTargetScroll(track, slides, index) {
    const slide = slides[index];
    if (!slide) return 0;

    return Math.max(
      0,
      slide.offsetLeft - track.offsetLeft - getTrackPadding(track)
    );
  }

  function getClosestSlideIndex(track, slides) {
    let closest = 0;
    let minDistance = Infinity;
    const padding = getTrackPadding(track);

    slides.forEach((slide, index) => {
      const distance = Math.abs(
        slide.offsetLeft - track.offsetLeft - padding - track.scrollLeft
      );

      if (distance < minDistance) {
        minDistance = distance;
        closest = index;
      }
    });

    return closest;
  }

  function buildPagination() {
    if (!paginationEnabled || !paginationEl) return;

    paginationEl.innerHTML = '';

    primarySlides.forEach((_, index) => {
      const dot = document.createElement('div');
      dot.type = 'button';
      dot.setAttribute('slide-dot-d5', '');
      dot.setAttribute('aria-label', `Go to slide ${index + 1}`);
      dot.style.setProperty('--autoplay-time', `${autoplayTime}ms`);

      if (index === currentIndex) dot.setAttribute('active', '');

      dot.addEventListener('click', () => {
        goTo(index);
        resetAutoplay();
      });

      paginationEl.appendChild(dot);
    });
  }

  function updateUI() {
    trackData.forEach(({ slides }) => {
      slides.forEach((slide, index) => {
        slide.classList.toggle('active', index === currentIndex);
      });
    });

    if (paginationEnabled && paginationEl) {
      paginationEl.querySelectorAll('[slide-dot-d5]').forEach((dot, index) => {
        if (index === currentIndex) dot.setAttribute('active', '');
        else dot.removeAttribute('active');
      });
    }

    if (countEnabled && countEl) {
      countEl.textContent = `${currentIndex + 1} / ${total}`;
    }

    if (arrowsEnabled) {
      if (prevBtn) prevBtn.disabled = currentIndex === 0;
      if (nextBtn) nextBtn.disabled = currentIndex === total - 1;
    }

    trackData.forEach(({ track }) => {
      const canScroll = track.scrollWidth > track.clientWidth + 1;
      track.classList.toggle('center', !canScroll);
    });
  }

  function goTo(index, sourceTrack = null) {
    const targetIndex = Math.max(0, Math.min(index, total - 1));
    currentIndex = targetIndex;
    isSyncing = true;

    trackData.forEach(({ track, slides }) => {
      if (track === sourceTrack) return;

      track.scrollTo({
        left: getTargetScroll(track, slides, targetIndex),
        behavior: 'smooth'
      });
    });

    updateUI();

    window.setTimeout(() => {
      isSyncing = false;
      updateUI();
    }, 450);
  }

  function startAutoplay() {
    if (!autoplayEnabled || isPlaying && autoplayTimer) return;

    slider.removeAttribute('ended');
    slideStartTime = Date.now();
    const delay = remainingTime ?? autoplayTime;
    remainingTime = null;

    autoplayTimer = window.setTimeout(() => {
      autoplayTimer = null;
      const nextIndex = currentIndex + 1;

      if (nextIndex >= total) {
        pauseAutoplay();
        slider.setAttribute('ended', '');
        return;
      }

      goTo(nextIndex);
      startAutoplay();
    }, delay);

    if (playPauseBtn) slider.setAttribute('playing', '');
    isPlaying = true;
  }

  function pauseAutoplay() {
    if (autoplayTimer !== null) {
      window.clearTimeout(autoplayTimer);
      autoplayTimer = null;
    }

    if (slideStartTime !== null) {
      const elapsed = Date.now() - slideStartTime;
      remainingTime = Math.max(0, autoplayTime - elapsed);
    }

    slideStartTime = null;
    if (playPauseBtn) slider.removeAttribute('playing');
    isPlaying = false;
  }

  function resetAutoplay() {
    pauseAutoplay();
    remainingTime = null;
    if (autoplayEnabled) startAutoplay();
  }

  // Keep all slider tracks synchronized when the user scrolls any track.
  trackData.forEach(({ track, slides }) => {
    let scrollTimer = null;

    const handleScrollEnd = () => {
      if (isSyncing) return;

      const closestIndex = getClosestSlideIndex(track, slides);
      if (closestIndex === currentIndex) return;

      currentIndex = Math.min(closestIndex, total - 1);
      isSyncing = true;

      trackData.forEach(({ track: otherTrack, slides: otherSlides }) => {
        if (otherTrack === track) return;

        otherTrack.scrollTo({
          left: getTargetScroll(otherTrack, otherSlides, currentIndex),
          behavior: 'smooth'
        });
      });

      updateUI();
      window.setTimeout(() => {
        isSyncing = false;
      }, 450);

      if (!slider.hasAttribute('ended')) resetAutoplay();
    };

    track.addEventListener('scroll', () => {
      window.clearTimeout(scrollTimer);
      scrollTimer = window.setTimeout(handleScrollEnd, 100);
    }, { passive: true });

    if ('onscrollend' in window) {
      track.addEventListener('scrollend', handleScrollEnd);
    }
  });

  if (arrowsEnabled) {
    if (nextBtn) {
      nextBtn.addEventListener('click', (event) => {
        event.preventDefault();
        if (currentIndex < total - 1) {
          goTo(currentIndex + 1);
          resetAutoplay();
        }
      });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', (event) => {
        event.preventDefault();
        if (currentIndex > 0) {
          goTo(currentIndex - 1);
          resetAutoplay();
        }
      });
    }
  }

  if (playPauseBtn) {
    playPauseBtn.addEventListener('click', () => {
      if (slider.hasAttribute('ended')) {
        pauseAutoplay();
        slider.removeAttribute('ended');
        remainingTime = null;
        goTo(0);
        window.setTimeout(startAutoplay, 500);
        return;
      }

      if (isPlaying) pauseAutoplay();
      else startAutoplay();
    });
  }

  window.addEventListener('resize', () => {
    trackData.forEach(({ track, slides }) => {
      track.scrollLeft = getTargetScroll(track, slides, currentIndex);
    });
    updateUI();
  });

  slider._startAutoplay = startAutoplay;
  buildPagination();
  updateUI();

  // Uncomment this line if autoplay should start automatically on page load.
  // if (autoplayEnabled) startAutoplay();
});

window.startAutoplayD5 = (sliderElement) => {
  const slider = sliderElement || document.querySelector('[slider-d5]');
  if (slider && typeof slider._startAutoplay === 'function') {
    slider._startAutoplay();
  }
};

(function initPcsSliders() {
  function initSlider(el) {
    if (el.dataset.pcsInitialized === 'true') return;
    el.dataset.pcsInitialized = 'true';

    const track = el.querySelector('[data-pcs-track]');
    const dots = el.querySelectorAll('[data-pcs-dot]');
    const prev = el.querySelector('[data-pcs-prev]');
    const next = el.querySelector('[data-pcs-next]');
    if (!track) return;

    const total = track.children.length;
    if (!total) return;

    let current = 0;

    function goTo(index) {
      current = Math.max(0, Math.min(total - 1, index));
      track.scrollTo({
        left: track.clientWidth * current,
        behavior: 'smooth'
      });

      dots.forEach((dot, dotIndex) => {
        dot.classList.toggle('is-active', dotIndex === current);
      });

      if (prev) prev.disabled = current === 0;
      if (next) next.disabled = current === total - 1;
    }

    if (prev) {
      prev.addEventListener('click', (event) => {
        event.preventDefault();
        goTo(current - 1);
      });
    }

    if (next) {
      next.addEventListener('click', (event) => {
        event.preventDefault();
        goTo(current + 1);
      });
    }

    dots.forEach((dot) => {
      dot.addEventListener('click', (event) => {
        event.preventDefault();
        goTo(Number(dot.dataset.pcsDot) || 0);
      });
    });

    let scrollTimer = null;
    track.addEventListener('scroll', () => {
      window.clearTimeout(scrollTimer);
      scrollTimer = window.setTimeout(() => {
        if (track.clientWidth) {
          const index = Math.round(track.scrollLeft / track.clientWidth);
          if (index !== current) goTo(index);
        }
      }, 80);
    }, { passive: true });

    goTo(0);
  }

  function observeSliders() {
    const sliders = document.querySelectorAll('[data-pcs]');
    if (!sliders.length) return;

    if (!('IntersectionObserver' in window)) {
      sliders.forEach(initSlider);
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          initSlider(entry.target);
          observer.unobserve(entry.target);
        }
      });
    }, { rootMargin: '200px' });

    sliders.forEach((el) => observer.observe(el));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeSliders, { once: true });
  } else {
    observeSliders();
  }
})();

function initPopupSliders() {
  document.querySelectorAll('.ap-popup-enable-d5').forEach((section) => {
    const triggers = section.querySelectorAll('.popup-slide-d5');
    const popup = section.querySelector('.ap-popup-con-d5');
    const contents = section.querySelectorAll('.ap-popup-content-d5');
    const closeButtons = popup?.querySelectorAll('[ap-popup-close-d5]');
    const videos = popup?.querySelectorAll('video');

    if (!popup || !closeButtons?.length) return;

    triggers.forEach((trigger) => {
      trigger.addEventListener('click', () => {
        const targetId = trigger.getAttribute('slide-index');
        const targetElement = targetId ? section.querySelector(`#${CSS.escape(targetId)}`) : null;

        contents.forEach((content) => content.classList.remove('active'));
        popup.classList.add('active');

        if (targetElement) {
          targetElement.classList.add('active');
          targetElement.querySelector('video')?.play().catch(() => {});
        }
      });
    });

    closeButtons.forEach((button) => {
      button.addEventListener('click', () => {
        videos?.forEach((video) => {
          video.pause();
          video.currentTime = 0;
        });

        popup.classList.remove('active');
        contents.forEach((content) => content.classList.remove('active'));
      });
    });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initPopupSliders, { once: true });
} else {
  initPopupSliders();
}